/* eslint-disable no-undef */
/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `
   {{#products}} 
	 <div class="wishlist-item"  x-data="wishlistItem" x-init="()=> { product_url = '{{du}}'}"  @mouseenter="hover = true" @mouseleave="hover = false">
	 <div x-show="item" x-transition>
		<button class="wishlist-item__remove swym-remove-product" :class="{ active: hover === true }" data-product-title="{{dt}}" data-variant-id="{{epi}}" data-product-id="{{empi}}">
			<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M17.3137 17.3137L9 8.99998M9 8.99998L0.68629 0.686268M9 8.99998L17.3137 0.686268M9 8.99998L0.686298 17.3137" stroke="#071D49"/>
			</svg>
		</button>
		<a href="{{du}}" class="wishlist-item__inner">
			<div class="wishlist-item__image-wrapper">
				<img alt="" class="swym-wishlist-image" :src="useImage(item?.media[0].src, 500)" x-show="!hover" x-transition>
				<img alt="" class="swym-wishlist-image" :src="useImage(item?.media[1].src, 500)" x-show="hover" x-transition>
			</div>
				<div class="wishlist-item__label" x-show="label">
					<span x-text="label" class="eyebrow small"></span>
				</div>
				<div class="wishlist-item__badge" x-show="priceCompare">
					<span x-text="sale"></span>
					<span> OFF | WORTH</span>
					<span x-text="priceCompare"></span>
				</div>
				<div class="wishlist-item__badge custom" x-show="!priceCompare && customBadge.text" :style="{color: customBadge.color, backgroundColor: customBadge.bg }">
					<span x-text="customBadge.text"></span>
				</div>
				<div class="wishlist-item__badge fake" x-show="!priceCompare && !customBadge.text">
					<span>xx</span>
					<span>OFF | WORTH</span>
					<span x-text="price"></span>
				</div>
				<h5 class="wishlist-item__title">
					{{dt}}
				</h5>
				<h4 class="wishlist-item__price-main" x-show="!priceCompare">
					<span class="wishlist-item__price" x-text="price"></span> 
					<span class="wishlist-item__size"> / {{vi}}</span>
				</h4>
				<h4 class="wishlist-item__price-container" x-show="priceCompare">
					<div class="wishlist-item__price-wrapper">
						<span class="wishlist-item__price-wrapper--price" x-text="price"></span>
						<del class="wishlist-item__price-wrapper--compare" x-text="priceCompare"></del>
					</div>
					<div class="wishlist-item__price-compare">
						(-<span class="wishlist-item__price-compare--sale" x-text="sale"></span>) 
						<span class="wishlist-item__price-compare--size">/ {{vi}}</span>
					</div>	
				</h4>
			</a>
			<button class="wishlist-item__add-to-bag btn secondary" @click.stop="addToCart" :class="{ freespace: priceCompare === '', active: hover === true }" :disabled="disable">
			<span x-show="!disable">ADD TO BAG</span>
			<span x-show="disable">OUT OF STOCK</span>
			</button>
			</div>
			<div class="wishlist-item__spinner" x-show="!item">
				<div class="spinner">
				</div>
			</div>
	 	</div>
   {{/products}}
	 `;

function getVariantInfo(variants) {
	try {
		let variantKeys = variants && variants != '[]' ? Object.keys(JSON.parse(variants)[0]) : [],
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == 'Default Title') {
				variantinfo = '';
			}
		} else {
			variantinfo = '';
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute('data-variant-id');
	var empi = +e.currentTarget.getAttribute('data-product-id');
	window._swat.fetch(function (products) {
		products.forEach(function (product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function () {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	});
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function (products) {
		var wishlistContentsContainer = document.getElementById('wishlist-items-container');
		var formattedWishlistedProducts = products.map(function (p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart;
			p.variantinfo = p.vi ? getVariantInfo(p.vi) : '';
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts,
		});
		window.dispatchEvent(new CustomEvent('wishlist'));
		if (wishlistContentsContainer) {
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else {
			console.log('Container not found, Wishlist Page element not found');
		}
	});

	const countHTMLElem = document.querySelector('#wishlist-count');
	const countMultipleHTMLElem = document.querySelector('#wishlist-counts');

	window._swat.renderWishlistCount(countHTMLElem, (count) => {
		window.dispatchEvent(new CustomEvent('wishlist-update-count', { detail: { count } }));
	});

	window._swat.renderWishlistCount(countMultipleHTMLElem, (count) => {
		window.dispatchEvent(new CustomEvent('wishlist-update-counts', { detail: { count } }));
	});
}

window.swymRenderWishlist = swymRenderWishlist;

function attachClickListeners() {
	var removeBtns = document.querySelectorAll('.swym-remove-product');
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
